module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex collect"
  }, [_c('m-header', {
    attrs: {
      "title": "邀请得大礼"
    }
  }), _vm._v(" "), _c('view-box', {
    staticClass: "collectBox",
    attrs: {
      "body-padding-bottom": "0"
    }
  }, [_c('p', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._v("分享此专属二维码给好友，邀请好友关注公众号，邀请人数达15人时获得礼品")]), _vm._v(" "), _c('p', [_vm._v("当前已邀请 " + _vm._s(_vm.invitedCount) + " 人")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-217ddc1d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/invite/invite.vue
// module id = 531
// module chunks = 0